/**
 * Wire codes for adaptive-content-egress failures, shared by the server that
 * emits them and the client that must recognise them.
 *
 * These live in `shared/` rather than server-side because both codes are
 * load-bearing on BOTH sides and a silent drift disables the control: the
 * client treats them as non-retryable (retrying an exhausted allowance only
 * makes it worse, and retrying a fail-closed budget store only makes it
 * slower), and it keys the daily-limit copy off the limit code so a burst-limit
 * 429 keeps its own distinct message. A one-sided string edit would turn a
 * quota block back into a retry storm with no test failing on either side.
 *
 * Server usage: `server/services/adaptive/contentEgress/egressError.ts`.
 * Client usage: `src/services/adaptiveEgressError.ts`.
 */

/** 429 — the actor's SGT-day allowance cannot cover this request. */
export const ADAPTIVE_EGRESS_LIMIT_ERROR_CODE = 'adaptive_content_limit_exceeded';

/** 503 — the ledger could not be read or written, so the request failed closed. */
export const ADAPTIVE_EGRESS_UNAVAILABLE_ERROR_CODE =
  'adaptive_content_budget_unavailable';

/** Body the server sends with a `429 adaptive_content_limit_exceeded`. */
export interface AdaptiveEgressLimitBody {
  error: typeof ADAPTIVE_EGRESS_LIMIT_ERROR_CODE;
  limit: number;
  used: number;
  requestedUnits: number;
  /** ISO timestamp of the next SGT midnight. */
  resetAt: string;
}
